import PlaceStatusModel          from '@models/website/PlaceStatusModel';
import StandModel                from '@models/website/StandModel';
import WebsiteEntertainmentModel from '@models/website/WebsiteEntertainmentModel';
import doc                       from '@widesk-core/decorators/doc';
import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import Blamable                  from '@/models/traits/Blamable';
import { Addable }               from '@widesk-core/decorators/addable';
import { Editable }              from '@widesk-core/decorators/editable';
import { Deletable }             from '@widesk-core/decorators/deletable';
import { Timestampable }         from '@widesk-core/decorators/timestampable';

@doc.path('/places/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractPlaceModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'partial': string;
		'private': string;
		'existsInContentToPublish': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'stand': id;
		'websiteEntertainment': id;
		'placeStatus': string;
		'placeUserGroups.userGroup': id;
		'planningPlaces.planning': id;
		'slug': id;
		'exists[stand]': string;
		'search': string;
	};

	declare private _tsSorts: {
		daisukiCount: string;
		id: string;
		private: string;
		position: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare slug: string;
	@doc.model(PlaceStatusModel) declare placeStatus: PlaceStatusModel;
	@doc.model(StandModel) declare stand: StandModel;
	@doc.boolean declare private: boolean;
	@doc.number declare position: number;
	@doc.model(WebsiteEntertainmentModel)
	declare websiteEntertainment: WebsiteEntertainmentModel;
}

interface AbstractPlaceModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractPlaceModel;
